
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { VideoThumbnailPipe, VideoStreamFilePipe } from './utils/video-thumbnail.pipe';
import * as Sentry from "@sentry/angular";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LandingPageComponent } from './_component/landing-page/landing-page.component';
import { HeaderComponent } from './_component/header/header.component';
import { FooterComponent } from './_component/footer/footer.component';
import { LoginComponent } from './_component/authorization/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {   MatRippleModule } from '@angular/material/core';
import {   MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';  
import {  MatFormFieldModule} from '@angular/material/form-field';
import { DialogModule } from 'primeng/dialog';
import { CommonModule } from '@angular/common';
import { NgOtpInputModule } from 'ng-otp-input';
import { ToastrModule } from 'ngx-toastr';
import { TqrComponent } from './_component/tqr/tqr.component';

import { ButtonModule } from 'primeng/button';
import { primeNg } from './primeNgControls';
import { ShakaPlayerComponent } from './_component/prime/shaka-player/shaka-player.component';
import { ShortsPlayerComponent } from './_component/prime/shorts-player/shorts-player.component';
import { CategoryService } from './_service/category.service';
import { TableModule } from 'primeng/table';
import { DownlaodnplaybackComponent } from './_component/downlaodnplayback/downlaodnplayback.component';
import { AuthenticateserviceService } from './_service/authenticateservice.service';
import { HttpConfigInterceptor } from './httpconfig.interceptor';
import { AuthGuard } from './_guard/authguard.guard';
import { MycontentComponent } from './_component/mycontent/mycontent.component';
import { MenubarModule } from 'primeng/menubar';
import { MenuModule } from 'primeng/menu';
import { GMapModule } from 'primeng/gmap';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SidebarModule } from 'primeng/sidebar';
import { InputMaskModule } from 'primeng/inputmask';
import { PasswordModule } from 'primeng/password';
import { InputTextModule } from 'primeng/inputtext';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { KeyFilterModule } from 'primeng/keyfilter';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { MultiSelectModule } from 'primeng/multiselect';
import { ChipsModule } from 'primeng/chips';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { CategoryComponent } from './_component/categories/category.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ChannelComponent } from './_component/channel/channel.component';
import { UserChannelComponent } from './_component/user-channel/user-channel.component';
import { AngularMaterialModule } from './angularMaterialControls';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SearchComponent } from './_component/search/search.component';
import { WatchlistComponent } from './_component/watchlist/watchlist.component';
import { WatchhistoryComponent } from './_component/watchhistory/watchhistory.component';
import { PercategoryComponent } from './_component/prime/percategory/percategory.component';
import { DownloadQualityDialogComponent, VideoDetailsComponent } from './_component/prime/video-details/video-details.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatCardModule } from '@angular/material/card';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AppLoaderComponent } from './common/app-loader/app-loader.component';
import { RegistrationComponent } from './_component/registration/registration.component';
import {DecryptPipe} from './utils/customPipes/decryptionPipe';
import { PrivacyComponent } from './_component/privacy/privacy.component';
import { DownloadlistComponent } from './_component/downloadlist/downloadlist.component';
import { ThumbnailViewComponent } from './_component/thumbnail-view/thumbnail-view.component';
import { DownloadProgressService } from './_service/download-progress.service';
import { CcPrimeMainComponent } from './_component/cc_prime/cc-prime-main/cc-prime-main.component';
import { CcPrimeCategoryComponent } from './_component/cc_prime/cc-prime-category/cc-prime-category.component';
import { SideBarComponent } from './_component/sharedComponents/side-bar/side-bar.component';
import { CcPrimePlayerComponent } from './_component/cc_prime/cc-prime-player/cc-prime-player.component';
import { MovieThumbnailComponent } from './_component/sharedComponents/movie-thumbnail/movie-thumbnail.component';
import { CategoryMovieComponent } from './_component/prime/category-movie/category-movie.component';
import { ToqqerRegisterComponent } from './_component/authorization/toqqer-register/toqqer-register.component';
import { LoaderComponent } from './loader/loader.component';
import { Router, NavigationEnd } from '@angular/router';
import { CcPrimeThumbnailComponent } from './_component/sharedComponents/cc-prime-thumbnail/cc-prime-thumbnail.component';
import { CustomCarouselComponent } from './_component/sharedComponents/custom-carousel/custom-carousel.component';
import { OfflineComponent } from './_component/sharedComponents/offline/offline.component';
import { AccountComponent } from './_component/account/account.component';
import { LoginShowComponent } from './_component/sharedComponents/login-show/login-show.component';
import { IndiaAuthComponent } from './_component/authorization/india-auth/india-auth.component';
import { OtherAuthComponent } from './_component/authorization/other-auth/other-auth.component';
import { OtherRegistrationComponent } from './_component/authorization/other-registration/other-registration.component';
import { BottomNavComponent } from './_component/sharedComponents/bottom-nav/bottom-nav.component';
import { Top10Component } from './_component/sharedComponents/top10/top10.component';
import { SubscriptionModalComponent } from './_component/sharedComponents/subscription-modal/subscription-modal.component';
import { CustomSnackbarComponent } from './_component/sharedComponents/custom-snackbar/custom-snackbar.component';
import { PaymentStatusModalComponent } from './_component/sharedComponents/payment-status-modal/payment-status-modal.component';
import { DeleteModalComponent } from './_component/sharedComponents/delete-modal/delete-modal.component';
import { WalletRewardsComponent } from './_component/wallet-rewards/wallet-rewards.component';
import { PaymentsComponent } from './_component/payments/payments.component';
import { ReportModalComponent } from './_component/sharedComponents/report-modal/report-modal.component';
import { ShareModalComponent } from './_component/sharedComponents/share-modal/share-modal.component';
import { MaintenanceComponent } from './_component/sharedComponents/maintenance/maintenance.component';
import { VidsSkeletonComponent } from './_component/sharedComponents/vids-skeleton/vids-skeleton.component';
import { FlixsSkeletonComponent } from './_component/sharedComponents/flixs-skeleton/flixs-skeleton.component';
import { QueueComponent } from './_component/queue/queue.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SpreadCarouselComponent } from './_component/sharedComponents/spread-carousel/spread-carousel.component';
import { CustomVideoPlayerComponent } from './_component/sharedComponents/custom-video-player/custom-video-player.component';
import { BannerComponent } from './_component/sharedComponents/banner/banner.component';
import { SettingsComponent } from './_component/settings/settings.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { VidsPlayerComponent } from './_component/sharedComponents/vids-player/vids-player.component';
import { WhiteLabelService } from './_service/white-label.service';
import { HorizantalViewComponent } from './_component/sharedComponents/horizantal-view/horizantal-view.component';
import { LogoHeaderComponent } from './_component/sharedComponents/logo-header/logo-header.component';
import { FlagFallbackDirective } from './utils/flag-fallback.directive';
import { EmailAuthComponent } from './_component/authorization/email-auth/email-auth.component';
import { NetworkbannerComponent } from './_component/sharedComponents/networkbanner/networkbanner.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { ScrollService } from './_service/scroll.service';
import { DynamicDialogModule, DialogService } from 'primeng/dynamicdialog';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { WhiteLabelInvalidComponent } from './_component/sharedComponents/white-label-invalid/white-label-invalid.component';
import { QRCodeModule } from 'angularx-qrcode';
import { GlobaldataService } from './_service/globaldata.service';
import { NativeAdComponent } from './_component/sharedComponents/native-ad.component';
import { AdBannerComponent } from './_component/sharedComponents/ad-banner.component';
import { TvGridKeyboardComponent } from './_component/sharedComponents/tv-grid-keyboard/tv-grid-keyboard.component';
import { ContentSkeletonComponent } from './_component/sharedComponents/content-skeleton/content-skeleton.component';
import { TvPurchaseRedirectModalComponent } from './_component/sharedComponents/tv-purchase-redirect-modal/tv-purchase-redirect-modal.component';
import { VideoPlayerTVController } from './_service/video-player-tv-controller.service';
import { IosFairplayPlayerComponent } from './_component/sharedComponents/ios-fairplay-player/ios-fairplay-player.component';
import { LoginPromptComponent } from './_component/sharedComponents/login-prompt/login-prompt.component';
import { LiveStreamSectionComponent } from './_component/sharedComponents/live-stream-section/live-stream-section.component';

export function initWhiteLabel(service: WhiteLabelService) {
  return () => service.init();
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    DecryptPipe,
    LandingPageComponent,
    HeaderComponent,
    FooterComponent,
    CategoryComponent,
    LoginComponent,
    TqrComponent,
  //  RegistrationComponent,
    ShakaPlayerComponent,
    ShortsPlayerComponent,
    DownlaodnplaybackComponent,
    MycontentComponent,
    ChannelComponent,
    UserChannelComponent,
    SearchComponent,
    WatchlistComponent,
    WatchhistoryComponent,
    PercategoryComponent,
    VideoDetailsComponent,
    AppLoaderComponent,
    RegistrationComponent,
    PrivacyComponent,
    DownloadlistComponent,
    ThumbnailViewComponent,
    CcPrimeMainComponent,
    CcPrimeCategoryComponent,
    SideBarComponent,
    CcPrimePlayerComponent,
    MovieThumbnailComponent,
    CategoryMovieComponent,
    ToqqerRegisterComponent,
    LoaderComponent,
    CcPrimeThumbnailComponent,
    CustomCarouselComponent,
    OfflineComponent,
    AccountComponent,
    LoginShowComponent,
    LoginPromptComponent,
    IndiaAuthComponent,
    OtherAuthComponent,
    OtherRegistrationComponent,
    BottomNavComponent,
    Top10Component,
    SubscriptionModalComponent,
    PaymentsComponent,
    WalletRewardsComponent,
    CustomSnackbarComponent,
    PaymentStatusModalComponent,
    DeleteModalComponent,
    ReportModalComponent,
    ShareModalComponent,
    TvPurchaseRedirectModalComponent,
    MaintenanceComponent,
    VidsSkeletonComponent,
    FlixsSkeletonComponent,
    QueueComponent,
    SpreadCarouselComponent,
    CustomVideoPlayerComponent,
    BannerComponent,
    SettingsComponent,
    VidsPlayerComponent,
    HorizantalViewComponent,
    LogoHeaderComponent,
    FlagFallbackDirective,
    EmailAuthComponent,
    NetworkbannerComponent,
    DownloadQualityDialogComponent,
    WhiteLabelInvalidComponent,
    AdBannerComponent,
    NativeAdComponent,
    IosFairplayPlayerComponent,
    TvGridKeyboardComponent,
    ContentSkeletonComponent,
    VideoThumbnailPipe,
    VideoStreamFilePipe,
    LiveStreamSectionComponent
  ],
  imports: [
    BrowserModule,
    MatTabsModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
   // AngularMaterialModule,
    DialogModule,
    CommonModule,
    ScrollingModule,
    //FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatRippleModule,
    MatMenuModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MenubarModule,
    MenuModule,
    GMapModule,
    OverlayPanelModule,
    ScrollPanelModule,
    SidebarModule,
    InputMaskModule,
    DialogModule,
    ButtonModule,
    PasswordModule,
    InputTextModule,
    CardModule,
    DropdownModule,
    ButtonModule,
    CalendarModule,
    AutoCompleteModule,
    CheckboxModule,
    KeyFilterModule,
    TabViewModule,
    TooltipModule,
    TableModule,
    MultiSelectModule,
    ChipsModule,
    RadioButtonModule,
    InputTextareaModule,
    MatToolbarModule,
    FormsModule,
    NgOtpInputModule,
    ToastrModule.forRoot(), 
    primeNg,
    ReactiveFormsModule,
    ButtonModule,
    CarouselModule,
    InfiniteScrollModule,
    MatSidenavModule,
    MatIconModule,
    AngularMaterialModule,
    MatCardModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    DynamicDialogModule,
    DialogModule,
    QRCodeModule,
    TranslateModule.forRoot(),
    ServiceWorkerModule.register(`ngsw-worker.js`, {
      enabled: environment.production,
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [
    CategoryService,
    AuthenticateserviceService,
    DownloadProgressService,
    ToastrModule,
    WhiteLabelService,
    AuthGuard,
    ScrollService,
    GlobaldataService,
    VideoPlayerTVController,
    { 
      provide: HTTP_INTERCEPTORS, 
      useClass: HttpConfigInterceptor, 
      multi: true 
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initWhiteLabel,
      deps: [WhiteLabelService],
      multi: true
    },
    {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({ showDialog: false }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor() {
  }
}
